/******************************************
 *      Upgoing transition for Dialogs    *
 ******************************************/

import { Slide } from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import { forwardRef } from "react";

const Transition: React.ForwardRefExoticComponent<
  TransitionProps & { children: React.ReactElement } & React.RefAttributes<unknown>
> = forwardRef(
  (
    props: TransitionProps & {
      children: React.ReactElement;
    },
    ref: React.Ref<unknown>,
  ): JSX.Element => {
    return <Slide direction="up" ref={ref} {...props} />;
  },
);

export default Transition;
